module.exports = __webpack_public_path__ + "img/pr-2.0f8023fa.png";